var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "94px",
    height: "71px",
    viewBox: "-0.5 -0.5 94 71",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2024-05-20T07:54:52.822Z\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:125.0) Gecko/20100101 Firefox/125.0\" etag=\"WeQL6-VSDzR9WokyV3dE\" version=\"24.4.4\" type=\"device\" scale=\"1\" border=\"0\"> <diagram name=\"\\u0421\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 \\u2014 1\" id=\"88RxBLOOm1hejg413ijC\"> <mxGraphModel dx=\"1125\" dy=\"314\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"827\" pageHeight=\"1169\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"077wQkvJ8ASjnkvQHjMA-1\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#825C39;strokeColor=#000000;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"-413\" y=\"300\" width=\"43\" height=\"60\" as=\"geometry\" /> </mxCell> <mxCell id=\"077wQkvJ8ASjnkvQHjMA-2\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFB570;strokeColor=#000000;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"-413\" y=\"310\" width=\"93\" height=\"60\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 43,
    height: 60,
    rx: 6.45,
    ry: 6.45,
    fill: "#825c39",
    stroke: "#000000",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 93,
    height: 60,
    rx: 9,
    ry: 9,
    fill: "#ffb570",
    stroke: "#000000",
    pointerEvents: "all"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPic);
export default __webpack_public_path__ + "static/media/folderPic.4dbf02c923dfd37cef96c47a5daf08f9.svg";
export { ForwardRef as ReactComponent };